import { render, staticRenderFns } from "./activity-html-detail.vue?vue&type=template&id=ec32a8d4&scoped=true&"
import script from "./activity-html-detail.vue?vue&type=script&lang=js&"
export * from "./activity-html-detail.vue?vue&type=script&lang=js&"
import style0 from "./activity-html-detail.vue?vue&type=style&index=0&id=ec32a8d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec32a8d4",
  null
  
)

export default component.exports